import { usePostOfficeBottomSheetState } from '@apps/postOffice/PostOffice.bottomSheet';

const useShareWithLinkController = () => {
  const { parentViewState } = usePostOfficeBottomSheetState();

  const handleCopyShareableLink = (generatedLink: string | null) => {
    if (parentViewState.handleCopyShareableLink && generatedLink) {
      parentViewState.handleCopyShareableLink(generatedLink);
    }
  };

  return {
    handleCopyShareableLink,
    isCreatingShareableLink: !!parentViewState.isCreatingShareableLink,
    generateShareableLink: parentViewState.generateShareableLink,
  };
};

export default useShareWithLinkController;
